import { exportTableDataToSpreadsheet } from 'src/utils/spreadsheet';

/**
 * The spreadsheet export, for the Options API pages that reach it as a mixin.
 *
 * THE IMPLEMENTATION MOVED to `utils/spreadsheet`, unchanged, so a `<script setup>` page can call
 * the same function rather than growing a second xlsx path that drifts from this one. This stays as
 * the mixin every existing table already uses.
 */
export default {
  methods: {
    exportTableDataToSpreadsheet(data, columns, filename) {
      return exportTableDataToSpreadsheet(data, columns, filename);
    },
  },
};
